import { useTranslation } from 'react-i18next'
import { Box, Grid } from '@mui/material'
import { useField } from 'formik'
import InputField from 'components/atoms/fields/InputField'
import { ISyllabusExpectation } from 'types'
import { syllabusExpectationAmountTypeSelectData, syllabusExpectationFrequencyTypeSelectData } from 'utils/helpers'
import SelectField from 'components/atoms/fields/SelectField'
import { useGET_setupOptionsQuery } from 'redux/api/setupApi'

const SyllabusExpectationList = ({ fieldProps, disabled }) => {
  
  const { t } = useTranslation()
  const [field] = useField<ISyllabusExpectation[]>(fieldProps.name)

  const { data: setupData } = useGET_setupOptionsQuery()

  return (
     setupData &&  <>
      { 
        field.value.map((value: ISyllabusExpectation, index: number) => ( 
                
          <Box 
            className={'transparent-background'}
            key={ index }
            sx={{
              padding: '1rem',
            }}>
            <Grid
              container
              spacing={4}
              sx={{ alignItems: 'center' }}
            >
              <Grid item xs={12} lg={4}>
                <InputField
                  valueSelector='title'
                  fieldProps={{
                    label: t('common.title'),
                    name: `${fieldProps.name}[${index}]`,
                  }}
                  disabled={disabled}
                />
              </Grid>

              {setupData.filter(sd => sd.slug == "syllabus_amount" && sd.is_enabled).length == 1 &&  <>
              <Grid item xs={6} lg={2}>
                <InputField
                  valueSelector='amount'
                  fieldProps={{
                    label: t('common.amount'),
                    name: `${fieldProps.name}[${index}]`,
                  }}
                  disabled={disabled}
                />
              </Grid>
              <Grid item xs={6} lg={2}>
                <SelectField
                  valueSelector='amount_choice'
                  renderChildren={false}
                  fieldProps={{
                    label: t('syllabuses.expectation-amount-period'),
                    name: `${fieldProps.name}[${index}]`,
                  }}
                  apiCall={syllabusExpectationAmountTypeSelectData}
                />
              </Grid></>}

              {setupData.filter(sd => sd.slug == "syllabus_frequency" && sd.is_enabled).length == 1 &&  <>
              <Grid item xs={6} lg={2}>
                <InputField
                  valueSelector='frequency'
                  fieldProps={{
                    label: t('common.frequency'),
                    name: `${fieldProps.name}[${index}]`,
                  }}
                  disabled={disabled}
                />
              </Grid>
              <Grid item xs={6} lg={2}>
                <SelectField
                  valueSelector='frequency_choice'
                  renderChildren={false}
                  fieldProps={{
                    label: t('syllabuses.expectation-frequency-period'),
                    name: `${fieldProps.name}[${index}]`,
                  }}
                  apiCall={syllabusExpectationFrequencyTypeSelectData}
                />
              </Grid></>}
              
            </Grid>

          </Box>
        ))
      }
    </>
  )

}
export default SyllabusExpectationList


